module.exports = __webpack_public_path__ + "img/logo_blue.4b837fe0.png";